import { useQuery } from "@tanstack/react-query";
import { generatePath } from "react-router-dom";
import { isSystemConfig } from "../../../system/api/requestHelper";
import { useApiRequest } from "../../../system/hooks/useApiRequest";
import { useConfig } from "../../../system/hooks/useConfig";
import {
  BRAND_SERVICE_LIST,
  BTAG_STATS_URL,
  BTAG_STATS,
  SERVICES_URL,
  btagMappingType,
  serviceListType,
} from "../constants";
import { getQueryParams } from "../../../system/helpers/urlHelper";

export const useServiceList = () => {
  const { apiRequest } = useApiRequest();
  const { config, brandId } = useConfig();

  return useQuery<serviceListType>({
    queryKey: [BRAND_SERVICE_LIST, brandId],
    queryFn: (): Promise<any> =>
      apiRequest({
        type: "GET_SERVICES_LIST",
        request: {
          url: generatePath(SERVICES_URL, { brandId }),
          method: "GET",
        },
      }),
    enabled: !isSystemConfig(config),
    staleTime: 0,
  });
};

export const useBtagStatsList = (search, page, pageSize) => {
    const { apiRequest } = useApiRequest();
    const { brandId } = useConfig();
    const params = getQueryParams({ ...search, page, per_page: pageSize });
    
    return useQuery<btagMappingType[]>({
      queryKey: [BTAG_STATS, search, page],
      queryFn: (): Promise<any> =>
        apiRequest({
          type: "GET_BTAG_STATS",
          request: {
            url: generatePath(BTAG_STATS_URL, { brandId }) + `?${params}`,
            method: "GET",
          },
        }),
    });
  };
